module.exports = {"title":"Events","subTitle":"Select Events for which the Flex Pass can be redeemed.","saveBtn":"Create Flex Pass","updateBtn":"Save Flex Pass","noEvents":"There are no events to display.","eventsTable":{"event":"Event","dateAndTime":"Date & time"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateFlexpass/FlexpassEvents/locales/fr.json
// module id = 1731
// module chunks = 0